export default __webpack_public_path__ + "static/full-001144d76da45953ba30dc85d5331a3e.webp";